/* eslint-disable react/jsx-key */
import React, { useState, useEffect, useContext, useRef, useMemo } from 'react'
import * as ScreenPermissions from 'core/EventActions'
import { dateCol, numCol } from '@integec/grid-tools/lib/cols'
import {
  modifierCol,
  modifiedDateCol,
  utilityHeader,
  unitIdHeader,
} from 'core/HeaderColTypeProps'
// eslint-disable-next-line no-unused-vars
import { getApiTargetInfo, ExportComponent, isAdminType } from 'core'
import { connect } from 'react-redux'
import R from 'ramda'
import { gettGenerationHourlyDOM, getDateHourList } from 'api/pgads.js'
import {
  getUtilityNameMap,
  getUnitNameMap,
  getUtilityUnitsMap,
  getPermitActions,
  getEnvConfig,
  getValidYearRange,
} from 'core/selectors'
// import ErrorModal from 'core/component/ErrorModal'

import { Button, Input, DatePicker, message, Tabs } from 'antd'
import {
  CriteriaRow,
  Title,
  Content,
  FullHeightSizer,
  Filler,
} from 'core/screen-util'
import Grid, {
  virtualizedGridRenderer,
  freeEditEngine,
} from '@integec/grid-tools'
import {
  rowHeaderRender,
  hasAccesPermits,
  // eslint-disable-next-line no-unused-vars
  exportDataComponent,
  isValidYearRange,
} from 'core/utils'
import moment from 'moment'
import HourlyGenerationDetailsDOM from './HourlyGenerationDetailsDOM'
import SelectUnit from 'reports/components/SelectUnits'
import {
  ErrorContext,
  SpinContext,
  DatePickerContext,
  UnitSelectionContext,
} from 'context'

const calcTotalHeader = [
  dateCol({
    ident: 'transdate',
    display: 'Transdate',
    isKey: true,
    width: 200,
  }),
  utilityHeader,
  unitIdHeader,
  numCol({ ident: 'totalGross', display: 'GROSS', isFiltered: true }),
  numCol({ ident: 'totalNet', display: 'NET', isFiltered: true }),
  numCol({ ident: 'totalSS', display: 'SS', isFiltered: true }),
  numCol({ ident: 'totalPump', display: 'PUMP', isFiltered: true }),
  numCol({ ident: 'totalSync', display: 'SYNC', isFiltered: true }),
  modifierCol,
  modifiedDateCol,
]

const title = 'Generation'

const HourlyGeneration = ({ apiTargetInfo, isAdminType = false, ...props }) => {
  const [insertEvent, setInsertEvent] = useState(false)
  const [activeKey, setActiveKey] = useState('data')
  const { setError } = useContext(ErrorContext)
  const { setSpinning } = useContext(SpinContext)
  const { selectedDateRangePicker, setSelectedDateRagePicker } = useContext(
    DatePickerContext
  )
  const {
    selectedUnits,
    setSelectedUnits,
    setVisibleUnitSelection,
  } = useContext(UnitSelectionContext)

  const { utilityNameMap, unitNameMap } = props

  const [dateHourList, setDateHourList] = useState([])
  useEffect(
    _ => {
      getDateHourList(apiTargetInfo)(
        selectedDateRangePicker[0],
        selectedDateRangePicker[1]
      ).fork(setError, setDateHourList)
    },
    [apiTargetInfo, selectedDateRangePicker, setError]
  )

  // const utilitysortOpt = (a, b) =>
  //   (utilityNameMap[a] || a).localeCompare(utilityNameMap[b] || b)
  // const unitsortOpt = (a, b) =>
  //   (unitNameMap[a] || '').localeCompare(unitNameMap[b])

  const headerWithFormatter = calcTotalHeader.map(header =>
    header.ident === 'utility'
      ? {
          ...header,
          // ...toSelectionColProps(utilityNameMap),
          dataFormatter: ({ value }) =>
            (utilityNameMap[value] &&
              `${value + '-' + utilityNameMap[value]}`) ||
            value,
          sortIndexGetter: ({ rowData }) =>
            utilityNameMap[rowData.utility] || rowData.utility,
        }
      : header.ident === 'unitId'
      ? {
          ...header,
          // choices: [],
          // dataGetter: this.generateDataGetter,
          dataFormatter: ({ value, rowData }) =>
            value.substr(value.length - 3) === 'ALL'
              ? 'ALL-ALL Units'
              : (unitNameMap[value] &&
                  `${rowData.unit + '-' + unitNameMap[value]}`) ||
                value,
          sortIndexGetter: ({ rowData }) =>
            unitNameMap[rowData.unit] || rowData.unit,
        }
      : /*: header.ident === 'effectiveMonth'
        ? {
            ...header,
            choices: mo nthOption,
          } */
        header
  )
  const [fuzzyFilter, setFuzzyFilter] = useState('')
  const GridRef = useRef()
  const GridRemainingRef = useRef()
  const [data, setData] = useState([])
  const [remData, setRemData] = useState([])
  // const [editInfo, setEditInfo] = useState(
  freeEditEngine.generateInitialEditInfo()
  // )

  const [selectedRows, setSelectedRows] = useState([])

  const selectionChange = ({ selectedRows }, ref) => {
    setSelectedRows(selectedRows)
    if (ref.current) {
      // ref.current.setSelectedRect({})
      // selR([])
    }
  }

  const clearData = _ => {
    setData([])
    setRemData([])
    setSelectedRows([])
    setActiveKey('data')
    setInsertEvent(false)
    // setEditInfo(freeEditEngine.generateInitialEditInfo())
  }

  useEffect(clearData, [selectedDateRangePicker])

  const calcTotal = (data, type) => {
    let calc = R.range(1, 25)
      .map(i => parseFloat(data[type + i] || 0))
      .reduce((a, b) => a + b)
    calc = calc + parseFloat(data[type + '2a'] || 0)
    return calc
  }

  const onRetrieveData = _ => {
    const isValid = isValidYearRange(
      props.validYearRange,
      selectedDateRangePicker[0],
      selectedDateRangePicker[1]
    )
    if (!isValid) return
    if (selectedUnits.length <= 0) {
      message.error('Please,Select Unit(s)')
      // setVisibleUnitSelection(true)
      return
    }

    setSpinning(true)
    const req = {
      startdate: selectedDateRangePicker[0].format('YYYY-MM-DD'),
      enddate: selectedDateRangePicker[1]
        .clone()
        .add(1, 'd')
        .format('YYYY-MM-DD'),
      unitid: selectedUnits.map(u => u.unitId),
    }
    gettGenerationHourlyDOM(apiTargetInfo)(req).fork(setError, data => {
      setSpinning(false)
      clearData()
      const incTotal = data.map(d => ({
        ...d,
        totalGross: calcTotal(d, 'gross'),
        totalNet: calcTotal(d, 'net'),
        totalSS: calcTotal(d, 'ss'),
        totalPump: calcTotal(d, 'pump'),
        totalSync: calcTotal(d, 'sync'),
      }))
      setData(incTotal)

      const startDate = selectedDateRangePicker[0].clone()
      const endDate = selectedDateRangePicker[1].clone().add(1, 'd')
      const selectedUnitIds = selectedUnits.map(u => u.unitId)
      const duration = moment.duration(endDate.diff(startDate))
      const days = duration.asDays()
      let remData = R.range(0, days).map(i =>
        selectedUnitIds.map(uid => ({
          isNew: true,
          transdate: startDate
            .clone()
            .add(i, 'days')
            .format('YYYY-MM-DD'),
          unitId: uid,
          utility: uid.substr(0, 3),
          unit: uid.substr(3),
          totalGross: 0,
          totalNet: 0,
          totalSS: 0,
          totalPump: 0,
          totalSync: 0,
        }))
      )

      remData = R.flatten(remData)

      remData = remData.filter(
        r =>
          !incTotal.find(
            d => d.transdate === r.transdate && r.unitId === d.unitId
          )
      )

      setRemData(remData)
    })
  }

  // eslint-disable-next-line no-unused-vars
  const adminPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: props.envConfig.authGodMode,
        actionPermits: props.actionPermits,
        eventActions: [ScreenPermissions.ADMIN_GENERATION_BY_HOUR_DOM],
        matchAny: true,
      }),
    [props.actionPermits, props.envConfig.authGodMode]
  )
  const [showUnit, setShowUnit] = useState(false)

  return (
    <div>
      {/* <UnitSelection /> */}
      <CriteriaRow
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr',
          gridTemplateRows: 'min-content 1fr',
          padding: '5px',
        }}
      >
        <Title
          style={{
            marginRight: '15px',
            marginBottom: '5px',
            marginLeft: '10px',
            minWidth: '100px',
            display: 'grid',
            justifyContent: 'center',
            paddingBottom: '10px',
          }}
        >
          {title}
        </Title>
        <CriteriaRow style={{ paddingTop: '0px' }}>
          <DatePicker.RangePicker
            style={{ marginLeft: '15px' }}
            allowClear={false}
            format="MM/DD/YYYY"
            value={selectedDateRangePicker}
            onChange={d => {
              setSelectedDateRagePicker(d)
              clearData()
              // retrieve({ dates: d })
            }}
          />
          <Button
            style={{ marginLeft: '15px' }}
            onClick={_ => setShowUnit(true)}
          >
            Select Units({selectedUnits.length})
          </Button>
          <Button
            style={{ marginLeft: '10px' }}
            onClick={_ => setInsertEvent(!insertEvent)}
            disabled={selectedRows.length <= 0}
            type="primary"
          >
            Enter/Edit Generation Data
          </Button>
          {/* <Button style={{ marginLeft: '15px' }}>Remove Selected</Button> */}
          <Button
            style={{ marginLeft: '10px' }}
            onClick={onRetrieveData}
            type="primary"
            icon="database"
          >
            Retrieve
          </Button>
          <Filler />
          <Input.Search
            placeholder="Filter"
            value={fuzzyFilter}
            style={{
              marginLeft: '10px',
              marginRight: '10px',
              flex: '0 0 200px',
              maxWidth: '200px',
            }}
            onChange={e => setFuzzyFilter(e.target.value)}
          />
          <ExportComponent
            getData={_ => exportDataComponent(GridRef, data, fuzzyFilter)}
            data={data}
            headers={(headerWithFormatter || []).map(d => ({
              ...d,
              rowHeaderBackgroundColor: '#eee',
            }))}
            fileName={title}
            btnStyle={{ marginRight: '10px' }}
            disabled={data.length <= 0}
          />

          {showUnit && (
            <SelectUnit
              title="Select Units"
              visible={showUnit}
              onOk={({ selUnits }) => {
                setSelectedUnits(selUnits)
                setVisibleUnitSelection(false)
                setShowUnit(false)
              }}
              onCancel={_ => {
                setShowUnit(false)
                setVisibleUnitSelection(false)
                setShowUnit(false)
              }}
              modalClose={_ => {
                setShowUnit(false)
                setVisibleUnitSelection(false)
              }}
            />
          )}
        </CriteriaRow>
      </CriteriaRow>
      {insertEvent && selectedRows.length >= 1 && (
        <Content style={{ padding: '5px', marginTop: '5px' }}>
          <HourlyGenerationDetailsDOM
            data={selectedRows[0]}
            apitargetInfo={apiTargetInfo}
            onMainRetrieveData={onRetrieveData}
            utilityNameMap={utilityNameMap}
            unitNameMap={unitNameMap}
            setInsertEvent={setInsertEvent}
            dateHourList={dateHourList}
            insertEvent={insertEvent}
            isAdminType={isAdminType}
            envConfig={props.envConfig}
            actionPermits={props.actionPermits}
          />
        </Content>
      )}
      <FullHeightSizer heightOffset={insertEvent ? 320 : 230}>
        {({ height, width }) => (
          <Content style={{ height: height - 20 }}>
            <Tabs
              style={{ height: height - 10, width }}
              activeKey={activeKey}
              onChange={setActiveKey}
            >
              <Tabs.TabPane tab="Data" key="data">
                <Grid
                  ref={GridRef}
                  sortEnabled
                  data={data}
                  headers={headerWithFormatter}
                  altBy={u => u.unitId}
                  altBgColor="#ebebeb"
                  // onEditInfoChange={info => editRow(info)}
                  // editInfo={editInfo}
                  render={virtualizedGridRenderer({
                    headerRowHeight: 30,
                    autoFixColByKey: false,
                    rowHeaderRender,
                    height: height - 100,
                    width: width - 50,
                    // cellRender: customizedCellRender,
                  })}
                  fuzzyFilter={fuzzyFilter}
                  isEditable={false}
                  onSelectionChange={rows => {
                    selectionChange(rows, GridRemainingRef)
                  }}
                  selectionMode="single"
                  selectionType="row"
                  initialSortOptions={[
                    unitIdHeader,
                    dateCol({
                      ident: 'transdate',
                      display: 'Transdate',
                      isKey: true,
                      width: 200,
                      sortOrder: 'asc',
                    }),
                  ]}
                />
              </Tabs.TabPane>
              <Tabs.TabPane tab="Remaining Data" key="remdata">
                <Grid
                  ref={GridRemainingRef}
                  sortEnabled
                  data={remData}
                  headers={headerWithFormatter}
                  altBy={u => u.unitId}
                  altBgColor="#ebebeb"
                  // onEditInfoChange={info => editRow(info)}
                  // editInfo={editInfo}
                  render={virtualizedGridRenderer({
                    headerRowHeight: 30,
                    autoFixColByKey: false,
                    rowHeaderRender,
                    height: height - 100,
                    width: width - 50,
                    // cellRender: customizedCellRender,
                  })}
                  fuzzyFilter={fuzzyFilter}
                  isEditable={false}
                  onSelectionChange={rows => {
                    selectionChange(rows, GridRef)
                  }}
                  selectionMode="single"
                  selectionType="row"
                  initialSortOptions={[
                    unitIdHeader,
                    dateCol({
                      ident: 'transdate',
                      display: 'Transdate',
                      sortOrder: 'asc',
                    }),
                  ]}
                />
              </Tabs.TabPane>
            </Tabs>
          </Content>
        )}
      </FullHeightSizer>
    </div>
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  utilityUnitMap: getUtilityUnitsMap(state),
  actionPermits: getPermitActions(state),
  envConfig: getEnvConfig(state),
  isAdminType: isAdminType(state),
  validYearRange: getValidYearRange(state),
})

export default connect(mapStateToProps)(HourlyGeneration)
